var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 8.97276L18.7631 11.0009C17.4967 12.2672 15.6182 12.5202 14.0891 11.7928L18.7631 7.11792C19.2994 6.58168 19.2994 5.71269 18.7631 5.17645L16.8229 3.23223C16.2866 2.69599 15.4189 2.69599 14.8812 3.23223L10.2058 7.90853C9.47972 6.37956 9.73412 4.49996 11.0006 3.23361L13.0275 1.20551C14.6364 -0.401837 17.245 -0.401837 18.8512 1.20551L20.7956 3.14698C22.4017 4.75571 22.4017 7.36404 20.7942 8.97276ZM7.11727 14.881C6.58097 14.3448 6.58097 13.4772 7.11727 12.9396L12.9409 7.11654C13.4772 6.5803 14.3449 6.5803 14.8826 7.11654C15.4189 7.65279 15.4189 8.5204 14.8826 9.05801L9.05894 14.881C8.52264 15.4187 7.65219 15.4187 7.11727 14.881ZM3.23393 16.8239L5.1756 18.7654C5.7119 19.3016 6.5796 19.3016 7.11727 18.7654L11.794 14.0891C12.5215 15.618 12.2671 17.4976 11.002 18.7654L9.14557 20.7935C7.53668 22.4022 4.92945 22.4022 3.32057 20.7935L1.20563 18.6801C-0.401878 17.0714 -0.401878 14.4644 1.20563 12.8557L3.23256 10.9995C4.50042 9.73313 6.37883 9.47876 7.90934 10.2075L3.23256 14.8824C2.69764 15.4187 2.69764 16.289 3.23393 16.8239Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4c308424554e32e6dac839ca6ee60326.svg";
export { ForwardRef as ReactComponent };